import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Column } from 'mage-components';
import { components as clientComponents } from 'mage-client';
import { Dropdown, Frame, IconCheckmark, IconClose, Link, ListPrimary, Loader, Typography, } from '@klarna/bubble-ui';
import { CAPS } from '@/constants';
import { getSupportedPlatforms } from '@/selectors/platforms';
import { getMerchantAwareTranslator } from '@/selectors/merchant';
import ExpandableFrame from './ExpandableFrame';
import { KlarnaLogo } from '@/components/ProductCard/KlarnaLogo';
const TitleWithKlarnaLogoContainer = styled.div.withConfig({ displayName: "TitleWithKlarnaLogoContainer", componentId: "sc-o9ghra" }) `
  display: flex;
  align-items: center;
`;
const componentPropTypes = {
    currentConfig: PropTypes.shape({
        PRICING_ANNEX: PropTypes.object.isRequired,
    }).isRequired,
    selectedCountry: PropTypes.string.isRequired,
};
const enhancedComponentPropTypes = {
    getProducts: PropTypes.func.isRequired,
    supportedPlatforms: PropTypes.array.isRequired,
    t: PropTypes.func.isRequired,
};
export const ProductsComponent = ({ selectedCountry, currentConfig, getProducts, supportedPlatforms, t, }) => {
    const [selectedPlatform, setSelectedPlatform] = useState('shopify');
    const [products, setProducts] = useState(null);
    useEffect(() => {
        setSelectedPlatform('shopify');
        setProducts(null);
    }, [selectedCountry]);
    useEffect(() => {
        setProducts(null);
        // eslint-disable-next-line promise/catch-or-return
        getProducts({
            params: { country: selectedCountry, platform: selectedPlatform },
        }).then((r) => setProducts(r.data.filter(({ id }) => id.includes('_one'))));
    }, [selectedCountry, selectedPlatform]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Frame, null,
            React.createElement(Row, null,
                React.createElement(Column, { columns: { mobile: 8 } },
                    React.createElement(Typography, { textToken: "text-style/headings/titles/bold/tertiary" }, "Products")),
                React.createElement(Column, { columns: { mobile: 4 } },
                    React.createElement(Dropdown, { label: "Platform", onChange: (v) => setSelectedPlatform(v), value: selectedPlatform, options: [
                            { key: '', label: '', disabled: true, hidden: true },
                            ...supportedPlatforms.filter(({ supportedCountries }) => supportedCountries.includes(selectedCountry)),
                        ], defaultValue: "shopify" })))),
        products ? (products.map(p => {
            var _a, _b;
            return (React.createElement(ExpandableFrame, { key: p.id, icon: p.isCompatible && p.isCountryCompatible ? (React.createElement(IconCheckmark, { colorToken: "colors/text/success" })) : (React.createElement(IconClose, { colorToken: "colors/text/error" })), title: React.createElement(React.Fragment, null,
                    React.createElement(TitleWithKlarnaLogoContainer, null,
                        React.createElement(KlarnaLogo, { type: p.id === 'kp_one' ? 'pink' : 'black' }),
                        t(`products-fe.products.${p.id}.name`))) },
                React.createElement(Typography, { textToken: "text-style/text/paragraphs/body/bold" }, "Meerkats Template ID:"),
                React.createElement(Typography, { textToken: "text-style/text/paragraphs/body/medium" }, p === null || p === void 0 ? void 0 : p.meerkatsTemplateId),
                React.createElement("br", null),
                React.createElement(Typography, { textToken: "text-style/text/paragraphs/body/bold" }, "Terms and Conditions:"),
                React.createElement(ListPrimary, { items: [
                        ...(((_a = p === null || p === void 0 ? void 0 : p.termsAndConditions) === null || _a === void 0 ? void 0 : _a.map((t, i) => (React.createElement(Link, { href: t.href, key: `${t}-${i}`, target: "_blank" },
                            "General terms: ",
                            t.country === 'default' ? 'All languages/countries' : t.country)))) || []),
                        React.createElement(Link, { href: (_b = currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.PRICING_ANNEX) === null || _b === void 0 ? void 0 : _b[p.id], key: "pricing-annex", target: "_blank" }, "Pricing Annex"),
                    ] })));
        })) : (React.createElement(Loader, null))));
};
ProductsComponent.propTypes = Object.assign(Object.assign({}, componentPropTypes), enhancedComponentPropTypes);
export const Products = compose(clientComponents.withPromiseBasedCapabilities({
    getProducts: CAPS.V2_PRODUCTS_GET,
}), connect(state => ({
    supportedPlatforms: getSupportedPlatforms(state),
    t: getMerchantAwareTranslator(state),
})))(ProductsComponent);
